<template>
  <!-- 仓库选择，支持单选/多选，左侧为部门分类树 -->
  <div class="warehouse-select">
    <div class="name el-select__prefix" @click="toShowDialog">
      <slot name="prefix"></slot>
    </div>
    <!-- 回显区：多选显示标签，单选显示名称，均可单独删除/清空 -->
    <div class="value" @click="toShowDialog">
      <template v-if="selectedItems.length">
        <div class="select-wrap">
          <div v-for="item in selectedItems" :key="item.id" :class="{'select-tag': multi}">
            <span class="tag-name">{{item.name}}</span>
            <yq-icon v-if="!disabled && multi" class="tag-close" name="element-ui_close" @click.stop="removeItem(item.id)"/>
          </div>
          <yq-icon v-if="!disabled" class="clear-all" name="element-ui_circle-close" @click.stop="clearData"/>
        </div>
      </template>
      <span v-else class="placeholder">{{placeholder}}</span>
    </div>
    <el-dialog v-model="showDialog" title="选择仓库" dialog-width="3" :close-on-click-modal="false" append-to-body @opened="tableDataBack">
      <dialog-table>
        <separate-page :show-shadow="false" :show-border="true">
          <template #category>
            <tree-dictionary v-model:dictionary-list="departTree" label-name="departName" code-name="departCode"
                             @clickCategory="clickCategory" :query-function="queryDepartList" :disabled="true" :filter="true"
                             placeholder="输入部门名称过滤"/>
          </template>
          <template #default>
            <list-page :show-shadow="false" :show-border="false">
              <search-condition :show-shadow="false" :show-border="false">
                <template #default>
                  <el-input v-model="dialogSearchInfo.searchKey" placeholder="请输入仓库名称/编码" @keydown.enter="resetSearchDialog">
                    <template #prefix>关键字</template>
                  </el-input>
                </template>
                <template #option>
                  <page-button type="read" el-type="primary" @click="resetSearchDialog">查询</page-button>
                </template>
              </search-condition>
              <table-list>
                <yq-table ref="selectTable" :data="dialogList" border :row-key="'id'" @selectionChange="dialogSelectionChange">
                  <yq-table-column v-if="multi" type="selection" width="60rem" align="center" fixed="left"/>
                  <yq-table-column label="仓库名称" prop="warehouseName" min-width="180rem"/>
                  <yq-table-column label="仓库编码" prop="warehouseCode"/>
                  <yq-table-column label="仓库类型" prop="warehouseType">
                    <template v-slot="{row}">
                      <el-tag size="small" :type="row.warehouseType === 1 ? 'info' : 'warning'">{{row.warehouseType === 1 ? '物资仓' : '临期仓'}}</el-tag>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="关联部门" prop="departName"/>
                  <yq-table-column v-if="!multi" label="操作" align="center" width="60rem" fixed="right">
                    <template v-slot="{row}">
                      <table-button @click="selectWarehouse(row)">选择</table-button>
                    </template>
                  </yq-table-column>
                </yq-table>
              </table-list>
              <form-page :show-shadow="false" :show-border="false" v-model:page-number="dialogSearchInfo.pageNumber" v-model:page-size="dialogSearchInfo.pageSize" :total-count="dialogSearchInfo.totalCount" @onLoad="dialogQueryList">
                <page-button @click="showDialog = false">取消</page-button>
                <page-button v-if="multi" type="read" el-type="primary" @click="confirmMulti">确定</page-button>
              </form-page>
            </list-page>
          </template>
        </separate-page>
      </dialog-table>
    </el-dialog>
  </div>
</template>

<script>


import {watch} from "vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableList from "@/components/h5/layout/ListTable.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import YqIcon from "@/components/YqIcon.vue";
import commonDataApi from "@/api/normal/common/commonDataApi";
import employeeApi from "@/api/normal/sys/employeeApi";
import commonApi from "@/api/commonApi";
// 选择一个仓库，用于表单或查询条件，支持单选/多选，左侧部门树过滤
export default {
  name: "WarehouseSelect",
  emits: ["change", "update:modelValue"],
  props: {
    modelValue: {
      type: [String, Array],
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择仓库"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否多选
    multi: {
      type: Boolean,
      default: false
    },
  },
  components: {
    YqIcon,
    TreeDictionary, FormItems, FormItem,
    TableButton, DialogTable, PageButton, TableList, FormPage, SeparatePage, YqTableColumn, ListPage, SearchCondition
  },
  data() {
    return {
      warehouseName: "",
      value: "",
      showDialog: false,
      dialogSearchInfo: {},
      dialogList: [],
      dialogSelected: [],
      departTree: [],
      selectedItems: [], // 回显的已选仓库 [{id, name: warehouseName}]
      isSelectData: false, // 是否前端选中了某个数据
    };
  },
  created() {
    this.init();
    this.queryDepartList();
    watch(() => this.modelValue, () => this.init());
  },
  methods: {
    // 查询部门树
    queryDepartList() {
      return new Promise(resolve => {
        commonApi.queryDepartList().then(res => {
          this.departTree = res || [];
          resolve(res);
        });
      });
    },
    // 当前选中的 id 列表
    currentIds() {
      if (!this.modelValue) return [];
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.filter(Boolean);
      }
      return String(this.modelValue).split(',').filter(Boolean);
    },
    init() {
      const ids = this.currentIds();
      if (!ids.length) {
        this.selectedItems = [];
        return;
      }
      if (this.isSelectData) {
        return;
      }
      commonDataApi.queryWarehouseByIds(ids).then(data => {
        let arr = [];
        for (let i = 0; i < data.length; i++) {
          arr.push({id: data[i].id, name: data[i].warehouseName});
        }
        this.selectedItems = arr;
      })
    },
    toShowDialog() {
      if (this.disabled) {
        return;
      }
      this.showDialog = true;
      if (!this.dialogList.length) {
        this.resetSearchDialog();
      }
    },
    // 对话框打开后回显已选（此时表格数据已加载）
    tableDataBack() {
      if (!this.multi || !this.$refs.selectTable) {
        return;
      }
      const ids = this.currentIds();
      if (!ids.length) {
        return;
      }
      this.$nextTick(() => {
        this.dialogList.forEach(row => {
          if (ids.includes(row.id)) {
            this.$refs.selectTable.getTable().toggleRowSelection(row, true);
          }
        });
      });
    },
    clickCategory(data) {
      this.dialogSearchInfo.departCode = data.departCode;
      this.resetSearchDialog();
    },
    resetSearchDialog() {
      this.dialogSearchInfo.pageNumber = 1;
      this.dialogQueryList();
    },
    dialogQueryList() {
      employeeApi.queryWarehouseList(this.dialogSearchInfo).then(res => {
        this.dialogList = res.records;
        this.dialogSearchInfo.totalCount = res.totalCount;
      })
    },
    dialogSelectionChange(list) {
      this.dialogSelected = list;
    },
    // 前端选中了某个数据
    selectDataFront() {
      this.isSelectData = true;
      setTimeout(() => this.isSelectData = false, 300);
    },
    // 单选选中某个仓库
    selectWarehouse(data) {
      this.value = data.id;
      this.warehouseName = data.warehouseName;
      this.selectedItems = [{id: data.id, name: data.warehouseName}];
      this.selectDataFront();
      this.$emit("update:modelValue", this.value);
      this.$emit("change", this.selectedItems.map(s => s.id).join(','));
      this.showDialog = false;
    },
    // 多选确定
    confirmMulti() {
      const rows = this.dialogSelected || [];
      if (!rows.length) {
        this.$message.error("请选择仓库");
        return;
      }
      this.selectedItems = rows.map(r => ({id: r.id, name: r.warehouseName || ''}));
      this.selectDataFront();
      this.$emit("update:modelValue", this.selectedItems.map(s => s.id).join(','));
      this.$emit("change", this.selectedItems.map(s => s.id).join(','));
      this.showDialog = false;
    },
    // 删除单个已选仓库
    removeItem(id) {
      this.selectedItems = this.selectedItems.filter(s => s.id !== id);
      const ids = this.selectedItems.map(s => s.id);
      this.selectDataFront();
      this.$emit("update:modelValue", this.multi ? ids.join(',') : (ids[0] || ''));
      this.$emit("change", ids.join(','));
    },
    clearData() {
      this.warehouseName = "";
      this.selectedItems = [];
      this.selectDataFront();
      this.$emit("update:modelValue", "");
      this.$emit("change", "");
    }
  }
};
</script>

<style lang="scss" scoped>
.warehouse-select{
  display: inline-flex !important;
  border: none !important;
  align-items: center;
  padding: 0 10px;
  min-width: 240px;
  box-sizing: border-box;
  border-radius: var(--el-border-radius-base);
  box-shadow: 0 0 0 0.02667rem var(--el-border-color) inset;
  min-height: 34px;
  font-size: 14px;
  position: relative;
  .name{
    font-size: 14px;
    color: var(--yq-font-color-base);
    gap: 0;
    &:not(:empty):after  {
      content: ":";
      margin-right: 8px;
    }
  }
  .value{
    flex: 1;
    color: #333;
    .placeholder{
      color: #999;
    }
  }
  .select-wrap{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 2px 0;
    .select-tag{
      display: inline-flex;
      align-items: center;
      padding: 0 8px;
      height: 22px;
      margin: 2px;
      background: var(--el-color-primary-light-9, #ecf5ff);
      border: 1px solid var(--el-color-primary-light-5, #b3d8ff);
      border-radius: 4px;
      font-size: 12px;
      color: var(--el-color-primary);
      .tag-close{
        margin-left: 4px;
        cursor: pointer;
        font-size: 12px;
        &:hover{
          color: var(--el-color-danger);
        }
      }
    }
    .clear-all{
      margin-left: 6px;
      cursor: pointer;
      font-size: 14px;
      color: var(--yq-font-color-tips, #909399);
      &:hover{
        color: var(--el-color-danger);
      }
    }
  }
}
.select-wrap{
  position: relative;
  .clear-all{
    position: absolute;
    right: 0;
    display: none;
  }
  &:hover{
    .clear-all{
      display: block;
    }
  }
}
</style>
